export default __webpack_public_path__ + "static/media/disc_conflict_sl_active.90f5e2ef.png";